import React, { useState } from 'react';
import { tval, tbval, tival, isVertical, media } from '@dsplay/template-utils';
import MenuBoard from './menu-board';
import { createPages } from '../ultis/utils';
import { useInterval } from '../ultis/use-interval';
import { styles, StylesContext } from './styles-context';

const menuData = {
  categories: [
    {
      cod: 1,
      title: "APPETIZERS",
      priceTitles: ["Preco"],
      items: [
        { num: "", title: "Naan Bread with Hummus", description: "Lightly cooked Naan Bread with Hummus", price1: "8.99" },
        { num: "", title: "Green Tomato Fries", description: "Green Tomatoes Fried with Corn Flour", price1: "12.99" },
        { num: "", title: "Loaded Tater Tots", description: "Fried Tater Tots with Bacon, Sour cream & Sauce", price1: "13.99" },
        { num: "", title: "Loaded Nachos", description: "Tortilla chips with Chilli, Sour cream and Bacon", price1: "14.99" },
        { num: "", title: "Cauliflower Fries", description: "Cauliflower Florets Battered with corn flour and lightly fried Served with Ranch or Blue cheese Buffalo Sauce ( Miild , Medium & Hot available for + $0.99)", price1: "12.99" },
        { num: "", title: "Pretzel", description: "Hot pretzel Glazed with butter and sprinkled with kosher Salt and Served with Tahini Sauce or House made Beer Dip every week or month.", price1: "9.99" },
        { num: "", title: "Salted Nut Mix", description: "Salted mix of 5-6 type of dried nuts", price1: "7.99" },
         {
              "num": "/fi(3, 8)",
              "title": "",
              "description": "",
              "price1": ""
            }
       
      ]
    },
    {
      cod: 2,
      title: "CLASSIC BURGER",
      priceTitles: ["Preco"],
      items: [
        { num: "", title: "CLASSIC BURGER", description: "Barbeque Seasoning, burger sauce, mayo, mustard, and dash of smoked paprika and splash of worcestershire sauce served on Brioche bun", price1: "12.99" },
        { num: "", title: "MISSION BURGER", description: "Tap′s favorite is a nice patty of Steak with Tarragon sauce and topped with Caramelized onions and served with a base of mayo and fresh white onions served with a brioche bun.", price1: "15.99" },
        { num: "", title: "CUBAN BURGER", description: "Beef patty flavored with Apple cider vinegar, garlic, tomato paste, liquid smoke, smoked paprika and oregano. A well established taste of florida favorite. Served on a cuban style bun", price1: "14.99" },
        { num: "", title: "MUSHROOM SWISS", description: "This burger is smashed in two small patties and cooked in hot sauce with Caramelized mushrooms on the top served on a brioche bun.", price1: "16.99" },
        { num: "", title: "BOMBAY BURGER", description: "A choice of robust mild mix of spices and topped with red and green spice cabbage ( apple cider vinegar, lime juice, garlic, cumin and spice mix)", price1: "14.99" },
        { num: "", title: "CHICKEN BURGER", description: "Minced chicken meat mixed with mild - hot spices topped with Garlic , Ginger & Fresh Cilantro and yogurt sauce with onions served on an Oat Bun", price1: "3.00" },
        { num: "", title: "BLUE & BISON BURGER", description: "Minced Bison patty served with base of Dijon Mustard, pickles, mixed greens and tomatoes served on a Sesame seed bun.", price1: "14.99" },
       
       {
              "num": "/fi(1, 12)",
              "title": "",
              "description": "",
              "price1": ""
            }
      ]
    },
    {
      cod: 3,
      title: "Wings",
      priceTitles: ["Preco"],
      items: [
        { num: "", title: "Buffalo Wings", description: "Naked wings glazed with Mild , Medium or Hot Sauce", price1: "17.99" },
        { num: "", title: "Barbeque Wings", description: "Barbeque Sauce glazed wings", price1: "17.99" },
        { num: "", title: "Lemon Pepper Wings", description: "Naked wings glazed with lemon pepper rub", price1: "17.99" },
        { num: "", title: "Indian Hot Spiced Wings", description: "OTHER RUBS : Mango Habanero, Hot Honey , Smoked Hickory, Sweet Teriyaki, Sweet Red Chili", price1: "19.99" },
        
        { num: "", title: "Naked wings Glazed in a mix of Parmesan Cheese", description: "Naked wings glazed with lemon pepper rub", price1: "10.99" },
        {
              "num": "/fi(5, 8)",
              "title": "",
              "description": "",
              "price1": ""
            }
      ]
    }
  ]
};

const {
  result: { data: mediaData },  // ✅ renamed here to avoid conflict
  duration,
} = media;

const showSectionPartials = tbval('showPartials', true);
const showFooter = tbval('footer', true);

const horizontal = !isVertical;
const screenSize = tval('screenSize', 'large');
const horizontalCols = screenSize === 'large' ? 3 : 2;
const verticalCols = screenSize === 'large' ? 2 : 1;

const cols = horizontal ? horizontalCols : verticalCols;

const options = {
    showSectionPartials,
    showFooter,
    horizontal,
    cols,
}

const pages = createPages(menuData, options);
let pageDuration = duration;

if (pages.length > 1) {
    const loopCount = tival('loopCount', 1);
    pageDuration = Math.floor(duration / (pages.length * loopCount));
}

const pseudoBodyStyles = {
    backgroundImage: `url('${styles.bgImage}')`,
};

const containerStyles = {
    borderTop: `1em solid ${styles.topBarColor}`,
    background: styles.background,
    fontSize: styles.fontSize,
};

function Container() {

    const [currentPage, setCurrentPage] = useState(0);
    useInterval(() => {
        setCurrentPage((currentPage + 1) % pages.length);
    }, pageDuration);

    return (
        <div style={pseudoBodyStyles} className="pseudo-body">
            <div style={containerStyles} className="main-container">
                <StylesContext.Provider value={styles}>
                    <MenuBoard
                        pages={pages}
                        index={currentPage}
                        cols={cols}
                    />
                </StylesContext.Provider>
            </div>
        </div>
    );

}

export default Container;